import { setTerm } from '@/packages/JsonQuery/helpers';

export const setHasFurniture = setTerm('has_furniture');
